import React, { useState } from 'react'
import { motion } from 'framer-motion'
import { Route } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { Link } from 'react-router-dom'

import Container, { CustomNavLink, TopMenuItem } from './styles'
import { logout } from 'store/reducers/user'
import { Icons, Popover } from '@valid/components'

const logo_min = `assets/${process.env.REACT_APP_THEME}/logo.png`

export default ({ component: Component, ...rest }) => {
  const account = useSelector((state) => state.user)
  const [menuEl, setMenuEl] = useState(null)

  const dispatch = useDispatch()
  const menuOpen = Boolean(menuEl)

  function handleLogout() {
    dispatch(logout())
  }

  const handleMenuButtonClick = (event) => {
    setMenuEl(event.currentTarget)
  }

  const handleMenuClose = () => {
    setMenuEl(null)
  }

  return (
    <Route
      {...rest}
      render={(matchProps) => (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.4 }}
        >
          <Container>
            <nav className="menu">
              <div className="menu__content">
                <img src={logo_min} alt="Logo" className="menu__logo" />

                <ul>
                  <li>
                    <CustomNavLink to="/dashboard">
                      <Icons icon="dashboard" /> Dashboard
                    </CustomNavLink>
                    <CustomNavLink to="/home">
                      <Icons icon="userRegister" /> Validar cliente
                    </CustomNavLink>
                  </li>
                </ul>
              </div>

              <div className="top_menu">
                <div>
                  <TopMenuItem onClick={handleMenuButtonClick}>
                    {account.username && account.username.titleCase().split(' ')[0]}
                    <Icons icon="menu" />
                  </TopMenuItem>

                  <Popover
                    open={menuOpen}
                    anchorEl={menuEl}
                    onClose={handleMenuClose}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                  >
                    {account.level === 'admin' &&
                      <Link to="/users">
                        <button type="button">
                          Gerenciar Usuários
                    </button>
                      </Link>
                    }
                    {account.level === 'admin' &&
                      <Link to="/dashboard/blocked">
                        <button type="button">
                          Desbloquear Clientes
                    </button>
                      </Link>
                    }
                    <button type="button" onClick={handleLogout}>
                      Sair
                    </button>
                  </Popover>
                </div>
              </div>
            </nav>

            <div className="content">
              <Component {...matchProps} />
            </div>
          </Container>
        </motion.div>
      )}
    />
  )
}
